// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2Q3bY","tab":"ProcedureTabs_tab__25Ie_"};